import { useState, useEffect } from 'react'

// approved
export const useFetchAllPermissions = ({marvarApi, dispatch, onLogout}) => {

    // 1. Para los datos recuperados de la BD
    const [dataPermissions, setDataPermissions] = useState([])
    
    // 2. Para mostrar animación de carga
    const [ loadingFetchPermissions, setLoadingFetchPermissions ] = useState(false)

    // 3. Para ejecutar el fetch desde alguna acción
    const [ execute, setExecute ] = useState(false)
    const executeFetch = async () => {
        setExecute(!execute)
    }

    const resetFetch = async () => {
        setDataPermissions([])
    }

    const fetchData = async () => {
        
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())

        try {
            
            const response = await marvarApi.get(`/permissions`)
            // console.log('[useFetchData][useFetchAllPermissions] response.data ', response.data)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        setLoadingFetchPermissions(true)
        fetchData()
            .then((resp) => {
                setDataPermissions(resp.rows)
                setLoadingFetchPermissions(false)
            })
            .catch(e => {
                console.log(e, '________ERROR')
                setLoadingFetchPermissions(false)
            })
    }, [execute])

    return { dataPermissions, loadingFetchPermissions, executeFetch, resetFetch }

}

// approved
export const useFetchSpecificPermission = ({marvarApi, dispatch, onLogout}) => {

    const [paramsToSearch, setParamsToSearch] = useState({idpermiso: ''})

    const [dataSpecificPermision, setDataSpecificPermision] = useState([])
    
    const [ loadingFetchSpecificPermission, setLoadingFetchSpecificPermission ] = useState(false)

    const [ execute, setExecute ] = useState(false)
    const executeFetch = async () => {
        setExecute(!execute)
    }

    const resetFetch = async () => {
        setDataSpecificPermision([])
    }

    const fetchData = async () => {
        
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())

        try {
            const response = await marvarApi.get(`/permissions/fetch-specific-permission/${paramsToSearch.idpermiso}`)
            console.log('[useFetchData][useFetchSpecificPermission] response.data ', response.data)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        if(paramsToSearch.idpermiso === '' && paramsToSearch.idpermiso>0){
            setLoadingFetchSpecificPermission(true)
            fetchData()
                .then((resp) => {
                    setDataSpecificPermision(resp.rows)
                    setLoadingFetchSpecificPermission(false)
                })
                .catch(e => {
                    console.log(e, '________ERROR')
                    setLoadingFetchSpecificPermission(false)
                })
        }
    }, [execute])

    return { dataSpecificPermision, loadingFetchSpecificPermission, setParamsToSearch, executeFetch, resetFetch }

}

export const useFetchInfoClient = ({marvarApi, dispatch, onLogout, Forms}) => {

    // 1. Para los datos recuperados de la BD
    // const [infoClient, setInfoClient] = useState([])
    const { FormClients } = Forms
    const { formState, setFormState } = FormClients
    
    // 2. Para mostrar animación de carga
    const [ loadingFetchInfoClient, setLoadingFetchInfoClient ] = useState(false)

    // 3. Para setear parametros de búsqueda al fetch
    const [paramsToSearch, setParamsToSearch] = useState({})

    // 4. Para ejecutar el fetch desde alguna acción
    const [ execute, setExecute ] = useState(false)
    const executeFetchInfoClient = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())
        try {
            
            const response = await marvarApi.get(`/clients/${paramsToSearch.idcliente}`)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        if(paramsToSearch.idcliente > 0 ){
            setLoadingFetchInfoClient(true)
            fetchData()
                .then((resp) => {
                    
                    // Setea en el estado del formulario los datos del registro
                    const { data } = resp
                    setFormState((prevState) => ({
                        ...prevState,
                        idcliente: data.idcliente || '',
                        nombre: data.nombre || '',
                        direccion: data.direccion || '',
                        telefono: data.telefono || '',
                        dpi: data.dpi || '',
                        correo: data.correo || ''
                    }))
                    setLoadingFetchInfoClient(false)

                })
                .catch(e => {
                    console.log(e, '________ERROR')
                    setLoadingFetchInfoClient(false)
                })
        }
    }, [execute])

    return { loadingFetchInfoClient, setParamsToSearch, executeFetchInfoClient }

}